import React, { FC } from "react";
import { Button, InputField } from "../forms";
import { ModalPropsDTO } from "../../typings/generic";
import { useStateGetter } from "../../hooks/statehooks/UseStateGettersHook";
import { useForm } from "react-hook-form";
import { emailReg, numReg, textReg } from "../../utils/regex";
import { ListPicker } from "../generic/ListPicker";
import { usePickerhook } from "../../hooks/usePickerhook";

const AddRoleModal = (props:any) => {
    var { control, handleSubmit, watch } = useForm();
const companypicker=usePickerhook()
const rolepicker=usePickerhook()
const onSubmit =()=>{



}
  return (
    <>
      <div className="ModalContainer shadow ">
        <div className=" flex flex-col justify-center items-center rounded-[8px] bg-white w-[40vw] p-4 overflow-y-scroll">
  
         <p className="font-semibold self-start text-sm ">Add Role</p>
         <div className=" grid grid-cols-2 gap-4">
         <InputField
            name="title"
            title="Role title"
            placeholder={"Role title"}
             control={control}
            rules={{
              required: "title is required",
              pattern: {
                value: textReg,
                message: "Invalid title",
              },
            }}
          />
      
         </div>

         <p className="font-semibold self-start text-sm my-2 ">Permissions</p>
         <p className="font-semibold self-start text-xs  ">Sales</p>

         <div className=" grid grid-cols-2 gap-4">
  <ListPicker hook={companypicker} title="Select permission" list={[]}  />
                     <ListPicker hook={rolepicker} title="Select permission" list={[]}  />

      
         </div>

         <p className="font-medium self-start text-xs mt-2 ">Inventory</p>
         <div className=" grid grid-cols-2 gap-4">
  <ListPicker hook={companypicker} title="Select permission" list={[]}  />
                     <ListPicker hook={rolepicker} title="Select permission" list={[]}  />

      
         </div>
         <div className=" flex justify-center items-center w-full gap-6">
              <Button
                 outlined
                 text="Cancel"
                onBtnClick={()=>{
                    props.show(false)
                }}
              />

<Button

               
                 text="Add user"
                onBtnClick={handleSubmit(onSubmit)}
              />
            </div>
        </div>
      </div>
    </>
  );
};

export default AddRoleModal;
